module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-ipt"
  }, [_c('div', {
    staticClass: "ipt_wrap",
    class: _vm.size
  }, [_c('input', {
    ref: "input",
    attrs: {
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "type": _vm.type,
      "maxlength": _vm.maxlength,
      "autocomplete": "off",
      "spellcheck": "false"
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "input": _vm.onInput,
      "focus": _vm.onFocus,
      "blur": _vm.onBlur
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ipt_extend"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    class: _vm.del_icon_clazz,
    on: {
      "click": _vm.onDelete
    }
  }, [_c('svg', {
    staticClass: "icon ",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": '#' + _vm.icontype
    }
  })])]), _vm._v(" "), _vm._t("icon-button")], 2), _vm._v(" "), _vm._t("button")], 2), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70aa1a8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Uinput.vue
// module id = 517
// module chunks = 1